"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = scrollTo;
function scrollTo(el, yOffset = 0) {
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
}
